import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BaseResourceService, produtoSaldo, FuncaoService, unidadeSaldo, loteSaldo } from 'eddydata-lib';
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class SaldoEstoqueService extends BaseResourceService<any> {

  constructor(
    protected injector: Injector
  ) {
    super(`saldos-estoque`, injector);
  }

  public obterProdutosComSaldo(estoque_id: number, parametros?: { codigo?: string, nome?: string, codigobarra?: string }): Observable<any[]> {
    let paramsWhere = '';
    if (parametros?.codigo) {
      paramsWhere += `?codigo=${parametros.codigo}`
    }
    if (parametros?.nome) {
      if (paramsWhere.length > 0)
        paramsWhere = '&';
      else
        paramsWhere = '?';
      paramsWhere += `nome=${parametros.nome}`
    }
    if (parametros?.codigobarra) {
      if (paramsWhere.length > 0)
        paramsWhere = '&';
      else
        paramsWhere = '?';
      paramsWhere += `codigo_barra=${parametros.codigobarra}`
    }
    return this.http.get<any[]>(
      `${this.login.cidade.id}/${this.api}/produtos-com-saldo/${estoque_id}${paramsWhere}`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => { return this.handleError(err) })
      );
  }


  public obterProdutosComSaida(estoque_id: number, parametros?: { codigo?: string, nome?: string, codigobarra?: string }): Observable<any[]> {
    let paramsWhere = '';
    if (parametros?.codigo) {
      paramsWhere += `?codigo=${parametros.codigo}`
    }
    if (parametros?.nome) {
      if (paramsWhere.length > 0)
        paramsWhere = '&';
      else
        paramsWhere = '?';
      paramsWhere += `nome=${parametros.nome}`
    }
    if (parametros?.codigobarra) {
      if (paramsWhere.length > 0)
        paramsWhere = '&';
      else
        paramsWhere = '?';
      paramsWhere += `codigo_barra=${parametros.codigobarra}`
    }
    return this.http.get<any[]>(
      `${this.login.cidade.id}/${this.api}/produtos-com-saida/${estoque_id}${paramsWhere}`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => { return this.handleError(err) })
      );
  }

  public obterSaldo(exercicio: number, orgao: number, setorAlmoxarifado: number, produtoUnidade: number, lote: string): Observable<number> {
    return this.http.get<number>(
      `${this.login.cidade.id}/${this.api}/saldo/${exercicio}/${orgao}/${setorAlmoxarifado}/${produtoUnidade}/${lote}`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => { return this.handleError(err) })
      );
  }

  public obterCustoMedio(orgao: number, estoque: number, produtoUnidade: number): Observable<number> {
    return this.http.get<number>(
      `${this.login.cidade.id}/${this.api}/custo-medio/${orgao}/${estoque}/${produtoUnidade}`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => { return this.handleError(err) })
      );
  }


  public saldoProduto(produto: number, estoque: number, movimento_item?: number): Observable<any> {
    let parametros = '';
    if (movimento_item)
      parametros = `?movimento_item=${movimento_item}`;
    return this.http.get<number>(
      `${this.login.cidade.id}/${this.api}/saldo-produto/${estoque}/${produto}${parametros}`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => { return this.handleError(err) })
      );
  }

  public saldoProdutoPorAlmoxarifado(produto: number, orgao: number): Observable<{ estoque: string, sum_entrada: number, sum_saida: number, saldo_atual: number }[]> {
    return this.http.get<any[]>(
      `${this.login.cidade.id}/${this.api}/saldo-produto-almoxarifado/${orgao}/${produto}`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => { return this.handleError(err) })
      );
  }

  public saldoProdutoPorSetor(produto: number, orgao: number): Observable<{ setor: string, sum_entrada: number, sum_saida: number, saldo_atual: number }[]> {
    return this.http.get<any[]>(
      `${this.login.cidade.id}/${this.api}/saldo-produto-setor/${orgao}/${produto}`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => { return this.handleError(err) })
      );
  }

  public saldoPorLote(produto_unidade: number, setor_almoxarifado: number, orgao: number, saida?: boolean): Observable<{
    lote: string, saldo: number, entrada: number, saida: number
  }[]> {
    let parametros = '';
    if (saida)
      parametros = `?saida=${saida}`;
    return this.http.get<any[]>(
      `${this.login.cidade.id}/${this.api}/saldo-lotes/${orgao}/${setor_almoxarifado}/${produto_unidade}${parametros}`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => { return this.handleError(err) })
      );
  }

  public saldoPorProduto(estoque: number, orgao: number, parametros?: {
    setor_id?: number, produto_unidade_id?: number,
    com_saldo?: boolean
  }): Observable<{
    priduto: string, unidade: string,
    codigo: string, sum_entrada: number,
    sum_saida: number, saldo_atual: number
  }[]> {
    let param = this.getParametros(parametros);
    return this.http.get<any[]>(
      `${this.login.cidade.id}/${this.api}/saldo-produtos/${orgao}/${estoque}?${param}`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => { return this.handleError(err) })
      );
  }

  public posicaoEstoque(estoque: number, data: Date, tipo: 'com_saldo' | 'mov_estoque' | 'todos' = 'mov_estoque', ordernacao: 'codigo' | 'produto' | 'subgrupo'): Observable<{
    produto_id: number,
    produto: string,
    codigo: string,
    minimo: number,
    maximo: number,
    subgrupo_id: number,
    subgrupo: string,
    produto_unidade_id: number,
    unidade: string,
    lote: string,
    saldo: number,
    consumo_medio: number,
    custo_medio: number
  }[]> {
    let data_ = new DatePipe('pt').transform(data, 'yyyy-MM-dd');
    return this.http.get<any[]>(
      `${this.login.cidade.id}/${this.api}/posicao-estoque/${estoque}/${data_}/${tipo}/N/${ordernacao}`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => { return this.handleError(err) })
      );
  }

  public fichaEstoque(estoque: number, produto_unidade_id, data_inicial: Date, data_final: Date): Observable<any> {
    let data_inicial_ = new DatePipe('pt').transform(data_inicial, 'yyyy-MM-dd');
    let data_final_ = new DatePipe('pt').transform(data_final, 'yyyy-MM-dd');
    return this.http.get<any[]>(
      `${this.login.cidade.id}/${this.api}/ficha-estoque/${estoque}/${produto_unidade_id}/${data_inicial_}/${data_final_}`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => { return this.handleError(err) })
      );
  }

  public balancoMensal(orgao: number, exercicio: number, mes: number, ordenacao: 'codigo'): Observable<any> {
    return this.http.get<any[]>(
      `${this.login.cidade.id}/${this.api}/balanco-mensal/${orgao}/${exercicio}/${mes}/${ordenacao}`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => { return this.handleError(err) })
      );
  }

  public saldoProdutoUnidadeLoteVencimento(produto_unidade_id: number, estoque_id: number,
    parametros?: { desc_item?: number, nao_obg_saldo?: boolean, saida_obrigatoria?: boolean }): Observable<any[]> {
    let query = this.converterParametrosStr(parametros);
    return this.http.get<any[]>(`${this.login.cidade.id}/${this.api}/saldo-produtos-lote-vencimento/${produto_unidade_id}/${estoque_id}${query}`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => { return this.handleError(err) }))
  }

  public reposicao(orgao: number, geral: boolean, ordenacao: string, subgrupo?: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.login.cidade.id}/${this.api}/reposicao-estoque/${orgao}/${geral ? 'S' : 'N'}/${ordenacao}`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => { return this.handleError(err) }))
  }

  public movimentacaoConsolidada(estoque: number, data1: string, data2: string, entrada: boolean, subgrupo?: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.login.cidade.id}/${this.api}/movimentacao-consolidada/${estoque}/${data1}/${data2}/${entrada ? 'S' : 'N'}`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => { return this.handleError(err) }))
  }
}
